module.exports = __webpack_public_path__ + "public/SiteIcons/correctWhyhost.svg?6baa6f27";